export const addFieldToObjects = (array, fieldName, fieldValue) => {
  return array.map((item) => ({
    ...item,
    [fieldName]: fieldValue,
  }));
};
